<form #theForm="ngForm" (ngSubmit)="ok()" [formGroup]="formData" novalidate>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      <span>Init configuration</span>
      @if (headline) {
        <span> - {{ headline }}</span>
      }
    </h4>
  </div>

  <div class="form-group modal-body">
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-12">
          <!-- Distribution -->
          <div formGroupName="distribution">
            <h2>Distribution</h2>
            <div class="panel panel-default panel-body">

              <!-- Distributions -->
              <ep-distribution-selector-multiple formControlName="distributionIds"
                (ngModelChange)="onDistributionsChange($event)">
              </ep-distribution-selector-multiple>

              <!-- Format Type -->
              <div class="form-group" [hidden]="distributionsChosen || documentConfigChosen">
                <label>Format type</label>
                <select class="form-control" formControlName="formatTypeId">
                  <option [ngValue]="null">Select...</option>
                  @for (item of formatTypes; track item) {
                    <option [ngValue]="item.Id">
                      {{item.Name}}
                    </option>
                  }
                </select>
              </div>

              <!-- Format / Variant / Version -->
              <fieldset [disabled]="disabled" [hidden]="distributionsChosen">
                <div class="form-group">
                    <ep-document-config-selector-simple #docConfigInSimple
                      titleText="Search by a specific ingoing format/variant version"
                      [direction]="Direction.In" [showAllOption]="true" [showConfigLinks]="documentConfigChosen"
                      (documentConfigChange)="onDocConfigChange($event)">
                    </ep-document-config-selector-simple>
                </div>
              </fieldset>

            </div>
          </div>
        </div>
      </div>

      <div class="row" [hidden]="distributionsChosen">
        <div class="col-md-6">
          <!-- Sender -->
          <div formGroupName="sender">
            <h2>Sender</h2>
            <div class="panel panel-default panel-body">
              <label>Partner</label>
              <ep-partner-selector #senderPartnerSelector
                [isReadOnly]="disabled"
                [showLoadingPartnerDetails]="false"
                (selectedPartnerIdChange)="selectedSenderPartnerIdChange($event)">
              </ep-partner-selector>

            </div>
          </div>
        </div>

        <div class="col-md-6">
          <!-- Receiver -->
          <div formGroupName="receiver">
            <h2>Receiver</h2>
            <div class="panel panel-default panel-body">
              <ep-partner-selector-multiple formControlName="partnerIds">
              </ep-partner-selector-multiple>

            </div>
          </div>
        </div>
      </div>

      <div class="row" formGroupName="disassemble">
        <div class="col-md-4">
          <!-- Disassemble -->
          <h2>Pre-Disassemble</h2>
          <div class="panel panel-default panel-body">

            <div class="form-group">
              <label>Pre-disassemble</label>
              <select class="form-control" formControlName="preDisassembleInitStepId" (ngModelChange)="initStepChanged($event, 'PreDisassemble')">
                <option [ngValue]="null">Select...</option>
                @for (item of initSteps; track item) {
                  <option
                    [ngValue]="item.Id"
                    [title]="item.Description">
                    {{item.Name}}
                  </option>
                }
              </select>
              @if (preDisassembleDisplayGroups.length > 0) {
                <ep-datafield-group-container [formValidationGroup]="formData" [showError]="true" [datafieldGroups]="preDisassembleDisplayGroups" [isAlwaysEditable]="!disabled" [numberOfColumns]="1"></ep-datafield-group-container>
              }
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <!-- Disassemble -->
          <h2>Custom Disassemble</h2>
          <div class="panel panel-default panel-body">
            <div class="form-group">
              <label>Custom disassemble</label>
              <select class="form-control" formControlName="customDisassembleInitStepId" (ngModelChange)="initStepChanged($event, 'CustomDisassemble')">
                <option [ngValue]="null">Select...</option>
                @for (item of initSteps; track item) {
                  <option
                    [ngValue]="item.Id"
                    [title]="item.Description">
                    {{item.Name}}
                  </option>
                }
              </select>
              @if (customDisassembleDisplayGroups.length > 0) {
                <ep-datafield-group-container [formValidationGroup]="formData" [showError]="true" [datafieldGroups]="customDisassembleDisplayGroups" [isAlwaysEditable]="!disabled" [numberOfColumns]="1"></ep-datafield-group-container>
              }
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <!-- Disassemble -->
          <h2>Post-Disassemble</h2>
          <div class="panel panel-default panel-body">
            <div class="form-group">
              <label>Post-disassemble</label>
              <select class="form-control" formControlName="postDisassembleInitStepId" (ngModelChange)="initStepChanged($event, 'PostDisassemble')">
                <option [ngValue]="null">Select...</option>
                @for (item of initSteps; track item) {
                  <option
                    [ngValue]="item.Id"
                    [title]="item.Description">
                    {{item.Name}}
                  </option>
                }
              </select>
              @if (postDisassembleDisplayGroups.length > 0) {
                <ep-datafield-group-container [formValidationGroup]="formData" [showError]="true" [datafieldGroups]="postDisassembleDisplayGroups" [isAlwaysEditable]="!disabled" [numberOfColumns]="1"></ep-datafield-group-container>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Document and interchange -->
      <div class="row">
        <div class="col-md-6">
          <div formGroupName="document">
            <h2>Document and interchange</h2>
            <div class="panel panel-default panel-body">

              <div class="form-group">
                <label>Document number macro</label>
                <input formControlName="documentNumberMacro" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <!-- Partner system -->
        <div class="col-md-6">
          <div formGroupName="partnerSystem">
            <h2>Partner system</h2>
            <div class="panel panel-default panel-body">
              <div class="form-group">
                <label>Partner system</label>
                <!-- <select class="form-control" formControlName="partnerSystemId" (ngModelChange)="selectedPartnerSystemIdChange($event)"> -->
                <select class="form-control" formControlName="partnerSystemId">
                  <option [ngValue]="null">Select...</option>
                  @for (item of partnerSystems; track item) {
                    <option
                      [ngValue]="item.Id"
                      [title]="item.Name">
                      {{item.Name}}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="text-center">
      @if (disabled) {
        <button type="button" class="btn btn-primary mw-12" (click)="cancel()">Close</button>
      }
      @if (!disabled) {
        <button type="submit" class="btn btn-primary mw-12"
          [disabled]="formData.invalid">
          OK
        </button>
      }
      @if (!disabled && showDelete) {
        <button type="button" class="btn btn-warning mw-12" (click)="delete()">Delete</button>
      }
      @if (!disabled) {
        <button type="button" class="btn btn-default mw-12" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</form>
